<script>
  import RowsContainer from "../container/RowsContainer.svelte";
  import StepperHeadline from "../stepper/StepperHeadline.svelte";

  import ColorPicker from "../ui/ColorPicker.svelte";

  export let model;
</script>

<div>
  <StepperHeadline>
    <h1>Choose your <span class="text-yellow">color</span></h1>
    <p>Get all your marketing assets branded with your color.<br />Choose a color from your logo or pick whatever you like.</p>
  </StepperHeadline>
  <RowsContainer>
    <div class="text-center">
    </div>
    <div class="text-center">
      <ColorPicker bind:model={model.mainColor} swatches={model.logoPalette} saveOnSelect={true}  />
    </div>
    <div class="text-center">
    </div>
  </RowsContainer>
</div>
